const BRIEF_REFERRER = {
    BRIEF: 'brief',
    LISTING: 'listing',
};

/**
 * @param {String[]} industries
 * @param {{[key: string]: boolean}} industriesTrackingData
 * @returns {IndustryTracking}
 */
const getIndustriesTrackingMap = (industries, industriesTrackingData = {}) => {
    if (!industriesTrackingData || !Object.keys(industriesTrackingData).length) {
        industriesTrackingData = industries.reduce((data, slug) => ({ ...data, [slug]: true }), {});
    }
    const { direct, related } = Object.keys(industriesTrackingData).reduce(
        ({ direct, related }, slug) => {
            const isDirect = industriesTrackingData[slug];
            if (isDirect) {
                return { related, direct: [...direct, slug] };
            }
            return { related: [...related, slug], direct };
        },
        {
            direct: [],
            related: [],
        }
    );

    return {
        ...(direct.length ? { direct: direct.join(',') } : {}),
        ...(related.length ? { related: related.join(',') } : {}),
    };
};

/**
 * Prepares brief data for being sent to the BigQuery.
 * @param {String} briefId
 * @param {Object} briefData
 * @param {Object} briefData.logo_name
 * @param {String} briefData.description
 * @param {String[]} briefData.industries
 * @param {Object} briefData.brand_values
 * @param {{[key: string]: boolean}} industriesTrackingData
 * @return {{makers_project: {brief: {metadata: string, brand_values: string, industries: string|IndustryTracking, business_description: string, id: string}}}}
 */
const getGeneralBriefTrackingData = (
    briefId,
    { logo_name = {}, description = '', industries = [], brand_values = {} } = {},
    industriesTrackingData,
    referrer = BRIEF_REFERRER.BRIEF
) => {
    let trackingIndustries;

    if (industriesTrackingData) {
        const complexIndustries = getIndustriesTrackingMap(industries, industriesTrackingData);
        trackingIndustries = complexIndustries && Object.values(complexIndustries).join(',');
    } else {
        trackingIndustries = industries.join(',');
    }

    return {
        makers_project: {
            brief: {
                id: briefId,
                industries: trackingIndustries,
                business_description: description,
                brand_values: JSON.stringify(brand_values),
                metadata: JSON.stringify({
                    brand_name: logo_name.brand_name,
                    slogan: logo_name.slogan,
                }),
            },
        },
        http_request: {
            referrer,
        },
    };
};

export const getBriefTrackingData = (briefId, briefData, industriesTrackingData) =>
    getGeneralBriefTrackingData(briefId, briefData, industriesTrackingData, BRIEF_REFERRER.BRIEF);

export const getListingBriefTrackingData = (briefId, briefData, industriesTrackingData) =>
    getGeneralBriefTrackingData(briefId, briefData, industriesTrackingData, BRIEF_REFERRER.LISTING);
